<template>
    <div class="footer">
        <!-- <div class="innerBox fr-ac-jsb">
                <div>
                    <p class="mb-17">版权所有： {{ footerInfo.corporation }}</p>
                    <p class="mb-17">公司地址： {{ footerInfo.address }}</p>
                    <p>
                        Copyright &copy;2020-{{ date }} gkzzd.cn|Alrights
                        reserved.|{{ footerInfo.corporation }}|<a
                            href="https://beian.miit.gov.cn/#/Integrated/index"
                            target="_blank"
                            >{{ footerInfo.beian }}</a
                        >
                    </p>
                </div>
                <div class="fr-ac-jc">
                    <div class="fc-ac-jc">
                        <el-image
                            :src="footerInfo.gzh_qrcode"
                            class="mb-10 footerImg"
                        ></el-image>
                        <p>微信公众号</p>
                    </div>
                    <div class="ml-25 fc-ac-jc">
                        <el-image
                            :src="footerInfo.xcx_qrcode"
                            class="mb-10 footerImg"
                        ></el-image>
                        <p>小程序</p>
                    </div>
                </div>
            </div> -->
        <div class="footer1 pb-30" style="border-bottom: 1px solid #4c4c4c">
            <p class="mb-7 fs-18" style="color: #fff">官方网站链接</p>
            <p>
                <a
                    class="hover title_a"
                    v-for="(item, ind) in link_list"
                    :key="ind"
                    :href="item.url"
                    target="_blank"
                    >{{ item.title }}</a
                >
            </p>
        </div>
        <div style="height: 30px"></div>
        <!-- <p class="mb-5">联系方式<span class="ml-10 mr-10">|</span>免责声明</p> -->
        <a class="hover" href="/school/contact" target="_blank">联系我们</a>
        <p class="mb-5">
            Copyright © 2017 - {{year}} gkzzd.cn All rights reserved.版权所有
            高考早知道
        </p>
        <a
            class="mb-5 hover"
            href="https://beian.miit.gov.cn/#/Integrated/index"
            target="_blank"
            >{{ footerInfo.beian }}</a
        >
        <p class="mb-5">福建互联网协会理事单位</p>
    </div>
</template>
<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import { getCookie, setCookie, setFavicon } from "@/utils/common";
export default {
    name: "school_article",
    //import引入的组件需要注入到对象中才能使用
    components: {},
    data() {
        return {
            footerInfo: {
                address: "",
                beian: "",
                corporation: "",
                gzh_qrcode: "",
                xcx_qrcode: "",
            },
            year: new Date().getFullYear(),
            tab_index: 1,
            link_list: [
                {
                    title: "教育部",
                    url: "http://www.moe.gov.cn/",
                },
                {
                    title: "教育部阳光高考信息平台",
                    url: "https://gaokao.chsi.com.cn/",
                },
                {
                    title: "福建省教育厅",
                    url: "https://jyt.fujian.gov.cn/",
                },
                {
                    title: "福建省教育考试院",
                    url: "https://www.eeafj.cn/",
                },
                // {
                //     title: "高宏教育",
                //     url: "https://www.gaohongedu.net/",
                // },
            ],
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {
        async getFooter() {
            const res = await this.$http.fetch("/api/homepage/foot", {});
            if (res.status == 200) {
                this.footerInfo.address = res.data.address;
                this.footerInfo.beian = res.data.beian;
                this.footerInfo.corporation = res.data.corporation;
                this.footerInfo.gzh_qrcode = res.data.gzh_qrcode;
                this.footerInfo.xcx_qrcode = res.data.xcx_qrcode;
            }
        },
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {},
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
        this.getFooter();
    },
    beforeCreate() {}, //生命周期 - 创建之前
    beforeMount() {}, //生命周期 - 挂载之前
    beforeUpdate() {}, //生命周期 - 更新之前
    updated() {}, //生命周期 - 更新之后
    beforeDestroy() {}, //生命周期 - 销毁之前
    destroyed() {}, //生命周期 - 销毁完成
    activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang="less" scoped>
.footer {
    background-color: #3c3c3c;
    padding: 30px 0;
    color: #999;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .footerImg {
        width: 84px;
        height: 82px;
    }
    .footer1 {
        width: 65%;
        display: flex;
        flex-direction: column;
    }
    .title_a {
        margin-left: 20px;
        &:first-child {
            margin-left: 0;
        }
    }
    .hover{
        &:hover {
            text-decoration: underline;
        }
    }
}
</style>